<template>
	<o-tour
		:ref="setup._tourOrderStatus"
		:callback="() => setup.endTourCallback()">
		<o-tour-step
			:title="$t('business.order.orderStatus')"
			size="md">
			<p>
				{{ $t('business.settings.agency.contract.orderStatusTabDesc') }}
			</p>
		</o-tour-step>
		<o-tour-step
			:title="$t('business.settings.agency.contract.progress')"
			target="order-details__stepper"
			size="lg">
			<p>
				{{ $t('business.settings.agency.contract.timelineDesc') }}
			</p>
			<ul>
				<li>{{ $t('business.settings.agency.contract.processingStatus') }}</li>
				<br>
				<li>{{ $t('business.settings.agency.contract.filledStatus') }}</li>

				<br>
				<li>{{ $t('business.settings.agency.contract.validatedStatus') }}</li>
				<br>
				<li>
					{{ $t('business.settings.agency.contract.contractsLinkedStatus') }}
				</li>
			</ul>
		</o-tour-step>
		<o-tour-step
			:title="$t('business.order.candidates')"
			target="candidates-status__container"
			size="md">
			<p>
				{{ $t('business.settings.agency.contract.candidatesSectionDesc') }}
			</p>
		</o-tour-step>
		<o-tour-step
			:title="$t('business.settings.agency.contract.help')"
			target="candidate-status-info"
			size="md"
			:next="setup.openHelpAside()">
			<p>
				{{ $t('business.settings.agency.contract.helpButtonDesc') }}
			</p>
		</o-tour-step>
		<o-tour-step
			:title="$t('business.settings.agency.contract.help')"
			target="order-status-helper"
			size="md"
			:previous="setup.closeAside()">
			<p>
				{{ $t('common.orderStatus.panelDescription') }}
			</p>
		</o-tour-step>
		<o-tour-step
			:title="$t('common.tour.legend')"
			target="order-details-status-helper-legend"
			size="md">
			<p>
				{{ $t('common.orderStatus.legendClickDescription') }}
			</p>
		</o-tour-step>
		<o-tour-step
			:title="$t('common.candidate.stickerLegend')"
			target="candidate-sticker-helper"
			size="md">
			<p>
				{{ $t('common.orderStatus.candidateStickerDescription') }}
				<br>
				{{ $t('common.orderStatus.statusMeaningDescription') }}
			</p>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import { inject } from 'vue';

const _aside = inject<OrionAside>('_aside');
// #region Setup
import type { TourOrderStatusEmits, TourOrderStatusProps } from './TourOrderStatusSetup';
import TourOrderStatusSetup from './TourOrderStatusSetup';
const emits = defineEmits<TourOrderStatusEmits>() as TourOrderStatusEmits;
const props = withDefaults(defineProps<TourOrderStatusProps>(), TourOrderStatusSetup.defaultProps);
const setup = new TourOrderStatusSetup(props, emits, _aside);
// #endregion
</script>
